import cloneDeep from 'lodash/cloneDeep';

import { APPLICATION_CONSTANTS } from 'AppConstants';
import { MICE_ACTION_CONSTANTS } from 'reduxStore/actionConstants';
import { failedFor, successFor } from 'reduxStore/reduxUtil';
import { SUBMISSION_MODAL, defaultOptionSelected } from '../../pages/mice/config';

const INITIAL_STATE = {
	ssr: false,
	apiLoader: false,
	apiStatus: '',
	formStaticData: {},
	openModal: '',
	modalData: {},
	searchFilterData: cloneDeep(defaultOptionSelected),
	hotelSearchData: {
		loading: false,
		error: false,
		success: false
	},
	metaData: {
		titleTxt: '',
		description: ''
	}
};

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	};
	const { type, payload = {} } = action;
	switch (type) {
		case MICE_ACTION_CONSTANTS.POST_DATA: {
			return {
				...state,
				apiLoader: true
			};
		};
		case successFor(MICE_ACTION_CONSTANTS.POST_DATA): {
			return {
				...state,
				apiLoader: false,
				apiStatus: APPLICATION_CONSTANTS.SUCCESS,
				openModal: SUBMISSION_MODAL
			};
		}
		case failedFor(MICE_ACTION_CONSTANTS.POST_DATA): {
			return {
				...state,
				apiLoader: false,
				apiStatus: APPLICATION_CONSTANTS.FAILED,
				openModal: SUBMISSION_MODAL
			};
		}
		case MICE_ACTION_CONSTANTS.SHOW_MODAL: {
			const { modalType, modalData } = payload;
			return {
				...state,
				openModal: modalType,
				modalData: modalData
			};
		}
		case MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA: {
			return {
				...state,
				hotelSearchData: {
					loading: true,
					error: false,
					success: false
				}
			};
		}
		case successFor(MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA): {
			const { formattedData, ssr } = payload;
			return {
				...state,
				hotelSearchData: {
					loading: false,
					error: false,
					success: true,
					...formattedData
				},
				ssr
			};
		}
		case failedFor(MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA): {
			return {
				...state,
				hotelSearchData: {
					loading: false,
					error: true,
					success: false
				}
			};
		}
		case MICE_ACTION_CONSTANTS.UPDATE_FILTER_SEARCH_DATA: {
			return {
				...state,
				searchFilterData: {
					...state.searchFilterData,
					...payload
				}
			};
		}
		case MICE_ACTION_CONSTANTS.UPDATE_SSR: {
			return {
				...state,
				ssr: payload
			};
		}
		case MICE_ACTION_CONSTANTS.SERVER_DEFAULT_DATA: {
			return {
				...state,
				...payload
			};
		}
		default:
			return state;
	}
};
